import { Component, Input } from "@angular/core";

@Component({
  selector: "bell-button",
  templateUrl: "./bell-button.component.html",
  styleUrls: ["./bell-button.component.scss"],
})
export class BellButtonComponent {
  @Input()
  transformCSS: string;

  constructor() {}
}
